import { render, staticRenderFns } from "./NfreshSubRowMobile.vue?vue&type=template&id=cb661ea0&scoped=true&"
import script from "./NfreshSubRowMobile.vue?vue&type=script&lang=ts&"
export * from "./NfreshSubRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./NfreshSubRowMobile.vue?vue&type=style&index=0&id=cb661ea0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb661ea0",
  null
  
)

export default component.exports